// extracted by mini-css-extract-plugin
export default {"ant-notification":"Uq3Rx","antNotification":"Uq3Rx","action-bar":"g0HXi","actionBar":"g0HXi"};